import { Injectable } from '@angular/core';
import { AnyType } from '@thehubz/shared/model';
import { TableColumn } from '../models';
import { UserPreferencesService } from '../services';
import { ViewType } from '../constants';

@Injectable({
  providedIn: 'root',
})
export class ProjectTaskCommonUtilityLib {
  constructor(private userPreferences: UserPreferencesService) {}

  /**
   * Handle sorting in columns;
   * Update column filterSelected value based on the saved filter sort
   */
  sortColumn(filterObject: AnyType, columns: TableColumn[]) {
    const sortKey = Object.keys(filterObject['sort']).toString();
    if (sortKey.includes('.')) {
      const sortKeyArray = sortKey.split('.');
      const [columnDef, showValue] = sortKeyArray;
      const index = columns.findIndex((obj) => obj.columnDef === columnDef && obj.showValue === showValue);
      columns[index].filterSelected = +Object.values(filterObject['sort']).toString();
    } else {
      const index = columns.findIndex((obj) => obj.columnDef === sortKey);
      columns[index].filterSelected = +Object.values(filterObject['sort']).toString();
    }
  }

  /**
   * Get view type saved for specific tab key
   * @returns
   */
  getViewType(tabKey: string, refKey: string): ViewType | undefined {
    return this.userPreferences.userPreference?.[refKey]?.[tabKey]?.['viewType'];
  }

  /**
   * Get tab sorting for specific tab key
   * @returns
   */
  getTabSorting(filterObject: AnyType, tabKey: string, refKey: string) {
    filterObject['sort'] = this.userPreferences.userPreference?.[refKey]?.[tabKey]?.['sort'] ?? { updatedAt: -1 };
  }
}
